export default "__VITE_ASSET__ZtoJbwaF__"